// extracted by mini-css-extract-plugin
module.exports = {"list":"list_list__jd__y","item":"list_item__jC4gy","with-custom-icons":"list_with-custom-icons__RM34w","item-with-icon":"list_item-with-icon__aFxp_","icon":"list_icon__Ocn3u"};